import BlockTypes from '../../../types/BlockTypes';
export default function ensureLastLine(editor) {
  editor.snapshotSelection().moveToEndOfDocument();
  var endBlock = editor.value.endBlock;

  if (endBlock.type !== BlockTypes.UNSTYLED || endBlock.text !== '') {
    editor.insertBlock(BlockTypes.UNSTYLED);
  }

  return editor.focus();
}